import i18next from 'i18next';

import { getManageCategoriesModalParams } from '@commons/constants/categoryTypes';

import {
  canUpdateSalesPointCategories,
  canUpdateCentralKitchenCategories,
} from '@selectors/actions/lossActions';

export const getActions = ({
  openLossCategoriesBatchUpdateModal,
  authorizedSalesPointActions,
  authorizedCentralKitchenActions,
  isCentralMode,
  openLossesExportModal,
  disableCategoriesUpdate,
}) => {
  const actions = [
    {
      id: 'export',
      label: i18next.t('LOSSES.PRODUCTS.ACTION_EXPORT'),
      icon: '/images/inpulse/file-download-black-small.svg',
      handleClick: openLossesExportModal,
    },
  ];

  if (
    (!isCentralMode && canUpdateSalesPointCategories(authorizedSalesPointActions)) ||
    (isCentralMode && canUpdateCentralKitchenCategories(authorizedCentralKitchenActions))
  ) {
    actions.unshift({
      id: 'handle-category',
      label: i18next.t('GENERAL.UPDATE_CATEGORIES'),
      icon: disableCategoriesUpdate
        ? '/images/inpulse/gear-lmgrey-small.svg'
        : '/images/inpulse/gear-ipblack-small.svg',
      isDisabled: disableCategoriesUpdate,
      handleClick: () => {
        openLossCategoriesBatchUpdateModal(false, [], getManageCategoriesModalParams());
      },
    });
  }

  return actions;
};
